import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        const path = location.pathname === "/" ? "/dashboard" : location.pathname;
        navigate(path, { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate, setUser]);

  return <div className="min-h-screen" data-testid="auth-callback" />;
};
